<div class="form-group">
  @if (hint) {
    <small class="text-muted">{{ hint }}</small>
  }
  <input class="form-control" [disabled]="disabled" [(ngModel)]="associationQuery" (keyup)="onQueryInput()" (paste)="onQueryInput()" [placeholder]="placeholder" />
</div>
@if (associationQuery) {
  <div class="product-results trans-bg border-radius10 p-10" [class.m-b-10]="showDone" [class.m-b-30]="!showDone">
    @if (searching) {
      <div class="text-center p-10">
        <fa-icon icon="spinner" animation="spin"></fa-icon>
        <span class="text-muted m-l-10">Searching...</span>
      </div>
    }
    @if (hasNoSearchResults) {
      <div class="text-center text-muted p-10">{{ searchEmptyMessage }}</div>
    }
    @if (hasSearchResults && isVideoType) {
      @for (video of associationResults; track video.id) {
        <myp-video-list-item (added)="onAdded(video)" [admin]="admin" [showAdd]="true" [video]="video"></myp-video-list-item>
      }
    }
    @if (hasSearchResults && isLessonType) {
      @for (lesson of associationResults; track lesson.id) {
        <myp-learn-list-item (added)="onAdded(lesson)" [showAdd]="true" [item]="lesson"></myp-learn-list-item>
      }
    }
  </div>
  @if (showDone) {
    <div class="product-results text-center trans-bg border-radius10 p-10 m-b-30">
      <button class="btn btn-sm btn-primary" (click)="clear()">Done</button>
    </div>
  }
}
